<script setup>
import { SecondaryButton } from "@Components/Button";
import { FormInput, FormLabel, FormListbox, FormTextarea } from "@Components/Form";
import { Disclosure, DisclosureButton, DisclosurePanel } from "@headlessui/vue";
import { ChevronDownIcon, ChevronUpIcon } from "lucide-vue-next";
import { useI18n } from "vue-i18n";

const props = defineProps({
    title: String,
    description: String,
    keywordLabel: String,
    keywordPlaceholder: String,
    keywordHelp: String,
    lengthLabel: String,
    lengthPlaceholder: String,
    lengthHelp: String,
    typeLabel: String,
    typePlaceholder: String,
    typeHelp: String,
    styleLabel: String,
    stylePlaceholder: String,
    styleHelp: String,
    customInstructionsLabel: String,
    customInstructionsPlaceholder: String,
    customInstructionsHelp: String,
});

const { t: __ } = useI18n();

const model = defineModel();

const typeItems = [
    {
        key: "match",
        name: __("Suggestions"),
    },
    {
        key: "similar",
        name: __("Similaire"),
    },
    {
        key: "related",
        name: __("En relation"),
    },
    {
        key: "questions",
        name: __("Questions"),
    },
    {
        key: "domain",
        name: __("Nom de domaine"),
    },
];

const styleItems = [
    {
        key: "informative",
        name: __("Informatif"),
    },
    {
        key: "commercial",
        name: __("Commercial"),
    },
    {
        key: "local",
        name: __("Local"),
    },
    {
        key: "brands",
        name: __("Marques"),
    },
    {
        key: "comparative",
        name: __("Comparatif"),
    },
    {
        key: "guide",
        name: __("Guide"),
    },
];
</script>
<template>
    <div class="flex flex-col space-y-6">
        <FormListbox
            v-model="model.type"
            :label="typeLabel"
            :help="typeHelp"
            :placeholder="typePlaceholder"
            :errors="model.getErrors('type')"
            :items="typeItems"
            itemKey="key"
            itemDisplay="name"
            required />

        <FormInput v-model="model.keyword" :label="keywordLabel" :help="keywordHelp" :placeholder="keywordPlaceholder" :errors="model.getErrors('keyword')" />

        <FormInput
            v-model="model.length"
            :label="lengthLabel"
            type="number"
            :help="lengthHelp"
            :placeholder="lengthPlaceholder"
            :errors="model.getErrors('length')" />

        <FormListbox
            v-model="model.style"
            :label="styleLabel"
            :help="styleHelp"
            :placeholder="stylePlaceholder"
            :errors="model.getErrors('style')"
            :items="styleItems"
            itemKey="key"
            itemDisplay="name"
            required />

        <Disclosure as="div" class="mt-2" v-slot="{ open }">
            <div class="flex flex-col space-y-2">
                <div class="flex justify-between items-center gap-3">
                    <FormLabel for="custom-instructions">{{ customInstructionsLabel }}</FormLabel>
                    <DisclosureButton :as="SecondaryButton" :icon="open ? ChevronUpIcon : ChevronDownIcon" type="button" />
                </div>
                <DisclosurePanel>
                    <FormTextarea
                        id="custom-instructions"
                        v-model="model.custom_instructions"
                        rows="5"
                        :help="customInstructionsHelp"
                        :placeholder="customInstructionsPlaceholder"
                        :errors="model.getErrors('custom_instructions')" />
                </DisclosurePanel>
            </div>
        </Disclosure>
    </div>
</template>
